import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PodcastRoom from "./components/podcast-room";
import PodcastArchive from "./components/podcast-archive";
import PodcastPaywall from "./components/paywall";
import { theme } from "./theme";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Redirect root URL to a newly generated room */}
        <Route path="/" element={<Navigate to={`/room/${Math.random().toString(36).substring(2, 8)}`} replace />} />
        
        {/* Checkout route */}
        <Route path="/checkout" element={<PodcastPaywall />} />

        {/* Archive route */}
        <Route path="/archive" element={<PodcastArchive pb={pb} currentTheme={theme.dark} />} />

        {/* Active room route */}
        <Route path="/room/:roomId" element={<PodcastRoom />} />
        
        {/* Fallback wildcard route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};
export default App;

